module.exports = __webpack_public_path__ + "img/layer-3.9c5e5aeb.svg";